var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactives-digital-will"},[_c('div',{staticClass:"will-title"},[_vm._v("Digital Will Generator")]),_vm._v(" "),_c('keep-alive',[_c(_vm.currentView,{tag:"component",attrs:{"formData":_vm.setupForm,"formValidator":_vm.formValidator,"templateData":_vm.templateForm},on:{"submitForm":_vm.formSubmitted,"back":_vm.goBack}},[_vm._v("Continue")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26d61372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 5suk
// module chunks = 1